import { render, staticRenderFns } from "./PxInputs.vue?vue&type=template&id=3376dca6&"
import script from "./PxInputs.vue?vue&type=script&lang=js&"
export * from "./PxInputs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports